import type { AuthenticateResponse } from '../../services/authentication/types';

/**
 * Calls the token endpoint (refresh_token grant). Pass tokenUrl from app env (e.g. AUTH_TOKEN_URL).
 * Returns new tokens; throws on non-ok response.
 */
export async function refreshToken(
	tokenUrl: string,
	refreshTokenValue: string,
	init?: RequestInit
): Promise<AuthenticateResponse> {
	const response = await fetch(tokenUrl, {
		method: 'POST',
		headers: { 'content-type': 'application/json' },
		body: JSON.stringify({
			grant_type: 'refresh_token',
			refresh_token: refreshTokenValue,
		}),
		...init,
	});

	if (!response.ok) {
		throw new Error('Session token expired');
	}

	let data: AuthenticateResponse;
	try {
		data = (await response.json()) as AuthenticateResponse;
	} catch {
		throw new Error('Invalid token response');
	}
	if (!data) {
		throw new Error('Could not load data');
	}
	return data;
}
